import { List } from '../objects/list';
import { Preferences } from '../../profile/objects/preferences';
import { ManualFlight } from '../../manualFlight/objects/manualFlight';
import { FlightFolderStatus, ManualFlightFolder } from '../objects/manualFlightFolder';

export const ADD_PREFERENCES = 'MANUAL_FLIGHT_FOLDER_ADD_PREFERENCES';
export const MOVE_DOWN_COLUMN = 'MANUAL_FLIGHT_FOLDER_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'MANUAL_FLIGHT_FOLDER_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'MANUAL_FLIGHT_FOLDER_RESET_FILTERS';
export const SET_EXPORT_TYPE = 'MANUAL_FLIGHT_FOLDER_SET_EXPORT_TYPE';
export const SET_LIMIT = 'MANUAL_FLIGHT_FOLDER_SET_LIMIT';
export const SET_LIST = 'MANUAL_FLIGHT_FOLDER_SET_LIST';
export const SET_MANUAL_FLIGHT = 'MANUAL_FLIGHT_FOLDER_SET_MANUAL_FLIGHT';
export const SET_ORDER_BY = 'MANUAL_FLIGHT_FOLDER_SET_ORDER_BY';
export const SET_PAGE = 'MANUAL_FLIGHT_FOLDER_SET_PAGE';
export const SET_PREFERENCES = 'MANUAL_FLIGHT_FOLDER_SET_PREFERENCES';
export const SET_RUNNING = 'MANUAL_FLIGHT_FOLDER_SET_RUNNING';
export const SET_SEARCH = 'MANUAL_FLIGHT_FOLDER_SET_SEARCH';
export const TOGGLE_COLUMN = 'MANUAL_FLIGHT_FOLDER_TOGGLE_COLUMN';
export const TOGGLE_EXPORT = 'MANUAL_FLIGHT_FOLDER_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'MANUAL_FLIGHT_FOLDER_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'MANUAL_FLIGHT_FOLDER_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'MANUAL_FLIGHT_FOLDER_TOGGLE_REFRESH';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_STATUS = 'MANUAL_FLIGHT_FOLDER_UPDATE_FILTER_STATUS';
export const SET_FLIGHT_FOLDER = 'MANUAL_FLIGHT_FOLDER_SET_FLIGHT_FOLDER';
export const TOGGLE_REFRESH_MANUAL_FLIGTH = 'MANUAL_FLIGHT_FOLDER_TOGGLE_REFRESH_MANUAL_FLIGTH';

interface ToggleRefreshManualFlightAction {
    type: typeof TOGGLE_REFRESH_MANUAL_FLIGTH,
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetManualFlightAction {
    type: typeof SET_MANUAL_FLIGHT,
    payload: ManualFlight
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterStatusAction {
    type: typeof UPDATE_FILTER_STATUS,
    payload: 'ALL' | 'EMPTY' | 'PENDING' | 'SOLD' | 'CANCELLED'
}
interface SetFlightFolderAction {
    type: typeof SET_FLIGHT_FOLDER,
    payload: (ManualFlightFolder & {new_status: FlightFolderStatus})  | null
}

export type ManualFlightFolderActionTypes =
    ToggleRefreshManualFlightAction |
    AddPreferencesAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetManualFlightAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterStatusAction | 
    SetFlightFolderAction;